class NullWrapper {
  toString () {
    return null
  }
  
  valueOf () {
    return null
  }
  
  [Symbol.toPrimitive] () {
    return null
  }
}

const NULL = Object.freeze(new NullWrapper())

export default NULL
